import React from 'react';
import { AppInsightsContext, withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import PriorAuthRequestSummary from '../../components/PrioAuthRequestSummary/PriorAuthRequestSummary.component';

const PriorAuthRequestSummaryWrapper: React.FC = () => (
  <AppInsightsContext.Provider value={reactPlugin}>
    <PriorAuthRequestSummary />
  </AppInsightsContext.Provider>
);
export default withAITracking(reactPlugin, PriorAuthRequestSummaryWrapper);
